import './Article.css.proxy.js';
/* src/components/car/Article.svelte generated by Svelte v3.35.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_text,
	create_component,
	destroy_component,
	destroy_each,
	detach,
	element,
	init,
	insert,
	mount_component,
	safe_not_equal,
	set_data,
	text,
	toggle_class,
	transition_in,
	transition_out
} from "../../web_modules/svelte/internal.js";

import { onMount } from "../../web_modules/svelte.js";
import Content from "../slot/Content.js";
import Options from "./Options.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[1] = list[i];
	return child_ctx;
}

function get_each_context_1(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[1] = list[i];
	return child_ctx;
}

// (58:130) {#if car.category}
function create_if_block(ctx) {
	let li;
	let t_value = (/*car*/ ctx[0].category.name || "カテゴリーなし") + "";
	let t;

	return {
		c() {
			li = element("li");
			t = text(t_value);
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true });
			var li_nodes = children(li);
			t = claim_text(li_nodes, t_value);
			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(li, "class", "category svelte-on555q");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, t);
		},
		p(ctx, dirty) {
			if (dirty & /*car*/ 1 && t_value !== (t_value = (/*car*/ ctx[0].category.name || "カテゴリーなし") + "")) set_data(t, t_value);
		},
		d(detaching) {
			if (detaching) detach(li);
		}
	};
}

// (58:274) {#each car.images as item}
function create_each_block_1(ctx) {
	let li;
	let div;
	let img;
	let img_src_value;

	return {
		c() {
			li = element("li");
			div = element("div");
			img = element("img");
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true });
			var li_nodes = children(li);
			div = claim_element(li_nodes, "DIV", { class: true });
			var div_nodes = children(div);

			img = claim_element(div_nodes, "IMG", {
				src: true,
				alt: true,
				loading: true,
				class: true
			});

			div_nodes.forEach(detach);
			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = /*item*/ ctx[1].getSized("large"))) attr(img, "src", img_src_value);
			attr(img, "alt", "");
			attr(img, "loading", "lazy");
			attr(img, "class", "svelte-on555q");
			attr(div, "class", "svelte-on555q");
			attr(li, "class", "svelte-on555q");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, div);
			append(div, img);
		},
		p(ctx, dirty) {
			if (dirty & /*car*/ 1 && img.src !== (img_src_value = /*item*/ ctx[1].getSized("large"))) {
				attr(img, "src", img_src_value);
			}
		},
		d(detaching) {
			if (detaching) detach(li);
		}
	};
}

// (58:477) {#each car.images as item}
function create_each_block(ctx) {
	let li;
	let div;
	let img;
	let img_src_value;

	return {
		c() {
			li = element("li");
			div = element("div");
			img = element("img");
			this.h();
		},
		l(nodes) {
			li = claim_element(nodes, "LI", { class: true });
			var li_nodes = children(li);
			div = claim_element(li_nodes, "DIV", { class: true });
			var div_nodes = children(div);

			img = claim_element(div_nodes, "IMG", {
				src: true,
				alt: true,
				loading: true,
				class: true
			});

			div_nodes.forEach(detach);
			li_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = /*item*/ ctx[1].getSized("large"))) attr(img, "src", img_src_value);
			attr(img, "alt", "");
			attr(img, "loading", "lazy");
			attr(img, "class", "svelte-on555q");
			attr(div, "class", "svelte-on555q");
			attr(li, "class", "svelte-on555q");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, div);
			append(div, img);
		},
		p(ctx, dirty) {
			if (dirty & /*car*/ 1 && img.src !== (img_src_value = /*item*/ ctx[1].getSized("large"))) {
				attr(img, "src", img_src_value);
			}
		},
		d(detaching) {
			if (detaching) detach(li);
		}
	};
}

function create_fragment(ctx) {
	let article;
	let div0;
	let h1;
	let t0_value = /*car*/ ctx[0].title + "";
	let t0;
	let ul0;
	let li0;
	let t1_value = (/*car*/ ctx[0].sold ? "成約済み" : "販売中") + "";
	let t1;
	let div2;
	let div1;
	let ul1;
	let span0;
	let t2;
	let span1;
	let t3;
	let ul2;
	let div4;
	let ul5;
	let li1;
	let p0;
	let t4_value = /*car*/ ctx[0].title + "";
	let t4;
	let div3;
	let p1;
	let span2;
	let t5;
	let strong0;
	let t6_value = (/*car*/ ctx[0].price ? /*car*/ ctx[0].price : "ASK") + "";
	let t6;
	let span3;
	let t7;
	let p2;
	let span4;
	let t8;
	let strong1;

	let t9_value = (/*car*/ ctx[0].totalPrice
	? /*car*/ ctx[0].totalPrice
	: "ASK") + "";

	let t9;
	let span5;
	let t10;
	let li5;
	let ul3;
	let li2;
	let p3;
	let t11;
	let p4;
	let t12_value = (/*car*/ ctx[0].maker?.name || "-") + "";
	let t12;
	let li3;
	let p5;
	let t13;
	let p6;
	let t14_value = (/*car*/ ctx[0].modelYear || "- ") + "";
	let t14;
	let t15;
	let li4;
	let p7;
	let t16;
	let p8;
	let t17_value = (/*car*/ ctx[0].vehicleInspection || "-") + "";
	let t17;
	let li9;
	let ul4;
	let li6;
	let p9;
	let t18;
	let p10;
	let t19_value = (/*car*/ ctx[0].capacity || "- ") + "";
	let t19;
	let t20;
	let li7;
	let p11;
	let t21;
	let p12;
	let t22_value = (/*car*/ ctx[0].mileage || "- ") + "";
	let t22;
	let t23;
	let li8;
	let p13;
	let t24;
	let p14;
	let t25_value = (/*car*/ ctx[0].repairHistory ? "有" : "無") + "";
	let t25;
	let div5;
	let options;
	let current;
	let if_block = /*car*/ ctx[0].category && create_if_block(ctx);
	let each_value_1 = /*car*/ ctx[0].images;
	let each_blocks_1 = [];

	for (let i = 0; i < each_value_1.length; i += 1) {
		each_blocks_1[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
	}

	let each_value = /*car*/ ctx[0].images;
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	options = new Options({
			props: { options: /*car*/ ctx[0].options }
		});

	return {
		c() {
			article = element("article");
			div0 = element("div");
			h1 = element("h1");
			t0 = text(t0_value);
			ul0 = element("ul");
			li0 = element("li");
			t1 = text(t1_value);
			if (if_block) if_block.c();
			div2 = element("div");
			div1 = element("div");
			ul1 = element("ul");

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].c();
			}

			span0 = element("span");
			t2 = text("◀︎");
			span1 = element("span");
			t3 = text("▶︎");
			ul2 = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			div4 = element("div");
			ul5 = element("ul");
			li1 = element("li");
			p0 = element("p");
			t4 = text(t4_value);
			div3 = element("div");
			p1 = element("p");
			span2 = element("span");
			t5 = text("本体価格");
			strong0 = element("strong");
			t6 = text(t6_value);
			span3 = element("span");
			t7 = text("万円（税込）");
			p2 = element("p");
			span4 = element("span");
			t8 = text("支払総額");
			strong1 = element("strong");
			t9 = text(t9_value);
			span5 = element("span");
			t10 = text("万円（税込）");
			li5 = element("li");
			ul3 = element("ul");
			li2 = element("li");
			p3 = element("p");
			t11 = text("メーカー");
			p4 = element("p");
			t12 = text(t12_value);
			li3 = element("li");
			p5 = element("p");
			t13 = text("年式");
			p6 = element("p");
			t14 = text(t14_value);
			t15 = text("年");
			li4 = element("li");
			p7 = element("p");
			t16 = text("車検有効期限");
			p8 = element("p");
			t17 = text(t17_value);
			li9 = element("li");
			ul4 = element("ul");
			li6 = element("li");
			p9 = element("p");
			t18 = text("排気量");
			p10 = element("p");
			t19 = text(t19_value);
			t20 = text("cc");
			li7 = element("li");
			p11 = element("p");
			t21 = text("走行距離");
			p12 = element("p");
			t22 = text(t22_value);
			t23 = text("km");
			li8 = element("li");
			p13 = element("p");
			t24 = text("修復歴");
			p14 = element("p");
			t25 = text(t25_value);
			div5 = element("div");
			create_component(options.$$.fragment);
			this.h();
		},
		l(nodes) {
			article = claim_element(nodes, "ARTICLE", {});
			var article_nodes = children(article);
			div0 = claim_element(article_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			h1 = claim_element(div0_nodes, "H1", { class: true });
			var h1_nodes = children(h1);
			t0 = claim_text(h1_nodes, t0_value);
			h1_nodes.forEach(detach);
			ul0 = claim_element(div0_nodes, "UL", { class: true });
			var ul0_nodes = children(ul0);
			li0 = claim_element(ul0_nodes, "LI", { class: true });
			var li0_nodes = children(li0);
			t1 = claim_text(li0_nodes, t1_value);
			li0_nodes.forEach(detach);
			if (if_block) if_block.l(ul0_nodes);
			ul0_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			div2 = claim_element(article_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			div1 = claim_element(div2_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			ul1 = claim_element(div1_nodes, "UL", { class: true });
			var ul1_nodes = children(ul1);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].l(ul1_nodes);
			}

			ul1_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			span0 = claim_element(div2_nodes, "SPAN", { class: true });
			var span0_nodes = children(span0);
			t2 = claim_text(span0_nodes, "◀︎");
			span0_nodes.forEach(detach);
			span1 = claim_element(div2_nodes, "SPAN", { class: true });
			var span1_nodes = children(span1);
			t3 = claim_text(span1_nodes, "▶︎");
			span1_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			ul2 = claim_element(article_nodes, "UL", { class: true });
			var ul2_nodes = children(ul2);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(ul2_nodes);
			}

			ul2_nodes.forEach(detach);
			div4 = claim_element(article_nodes, "DIV", { class: true });
			var div4_nodes = children(div4);
			ul5 = claim_element(div4_nodes, "UL", { class: true });
			var ul5_nodes = children(ul5);
			li1 = claim_element(ul5_nodes, "LI", { class: true });
			var li1_nodes = children(li1);
			p0 = claim_element(li1_nodes, "P", { class: true });
			var p0_nodes = children(p0);
			t4 = claim_text(p0_nodes, t4_value);
			p0_nodes.forEach(detach);
			div3 = claim_element(li1_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			p1 = claim_element(div3_nodes, "P", { class: true });
			var p1_nodes = children(p1);
			span2 = claim_element(p1_nodes, "SPAN", {});
			var span2_nodes = children(span2);
			t5 = claim_text(span2_nodes, "本体価格");
			span2_nodes.forEach(detach);
			strong0 = claim_element(p1_nodes, "STRONG", { class: true });
			var strong0_nodes = children(strong0);
			t6 = claim_text(strong0_nodes, t6_value);
			strong0_nodes.forEach(detach);
			span3 = claim_element(p1_nodes, "SPAN", {});
			var span3_nodes = children(span3);
			t7 = claim_text(span3_nodes, "万円（税込）");
			span3_nodes.forEach(detach);
			p1_nodes.forEach(detach);
			p2 = claim_element(div3_nodes, "P", { class: true });
			var p2_nodes = children(p2);
			span4 = claim_element(p2_nodes, "SPAN", {});
			var span4_nodes = children(span4);
			t8 = claim_text(span4_nodes, "支払総額");
			span4_nodes.forEach(detach);
			strong1 = claim_element(p2_nodes, "STRONG", { class: true });
			var strong1_nodes = children(strong1);
			t9 = claim_text(strong1_nodes, t9_value);
			strong1_nodes.forEach(detach);
			span5 = claim_element(p2_nodes, "SPAN", {});
			var span5_nodes = children(span5);
			t10 = claim_text(span5_nodes, "万円（税込）");
			span5_nodes.forEach(detach);
			p2_nodes.forEach(detach);
			div3_nodes.forEach(detach);
			li1_nodes.forEach(detach);
			li5 = claim_element(ul5_nodes, "LI", { class: true });
			var li5_nodes = children(li5);
			ul3 = claim_element(li5_nodes, "UL", { class: true });
			var ul3_nodes = children(ul3);
			li2 = claim_element(ul3_nodes, "LI", { class: true });
			var li2_nodes = children(li2);
			p3 = claim_element(li2_nodes, "P", { class: true });
			var p3_nodes = children(p3);
			t11 = claim_text(p3_nodes, "メーカー");
			p3_nodes.forEach(detach);
			p4 = claim_element(li2_nodes, "P", { class: true });
			var p4_nodes = children(p4);
			t12 = claim_text(p4_nodes, t12_value);
			p4_nodes.forEach(detach);
			li2_nodes.forEach(detach);
			li3 = claim_element(ul3_nodes, "LI", { class: true });
			var li3_nodes = children(li3);
			p5 = claim_element(li3_nodes, "P", { class: true });
			var p5_nodes = children(p5);
			t13 = claim_text(p5_nodes, "年式");
			p5_nodes.forEach(detach);
			p6 = claim_element(li3_nodes, "P", { class: true });
			var p6_nodes = children(p6);
			t14 = claim_text(p6_nodes, t14_value);
			t15 = claim_text(p6_nodes, "年");
			p6_nodes.forEach(detach);
			li3_nodes.forEach(detach);
			li4 = claim_element(ul3_nodes, "LI", { class: true });
			var li4_nodes = children(li4);
			p7 = claim_element(li4_nodes, "P", { class: true });
			var p7_nodes = children(p7);
			t16 = claim_text(p7_nodes, "車検有効期限");
			p7_nodes.forEach(detach);
			p8 = claim_element(li4_nodes, "P", { class: true });
			var p8_nodes = children(p8);
			t17 = claim_text(p8_nodes, t17_value);
			p8_nodes.forEach(detach);
			li4_nodes.forEach(detach);
			ul3_nodes.forEach(detach);
			li5_nodes.forEach(detach);
			li9 = claim_element(ul5_nodes, "LI", { class: true });
			var li9_nodes = children(li9);
			ul4 = claim_element(li9_nodes, "UL", { class: true });
			var ul4_nodes = children(ul4);
			li6 = claim_element(ul4_nodes, "LI", { class: true });
			var li6_nodes = children(li6);
			p9 = claim_element(li6_nodes, "P", { class: true });
			var p9_nodes = children(p9);
			t18 = claim_text(p9_nodes, "排気量");
			p9_nodes.forEach(detach);
			p10 = claim_element(li6_nodes, "P", { class: true });
			var p10_nodes = children(p10);
			t19 = claim_text(p10_nodes, t19_value);
			t20 = claim_text(p10_nodes, "cc");
			p10_nodes.forEach(detach);
			li6_nodes.forEach(detach);
			li7 = claim_element(ul4_nodes, "LI", { class: true });
			var li7_nodes = children(li7);
			p11 = claim_element(li7_nodes, "P", { class: true });
			var p11_nodes = children(p11);
			t21 = claim_text(p11_nodes, "走行距離");
			p11_nodes.forEach(detach);
			p12 = claim_element(li7_nodes, "P", { class: true });
			var p12_nodes = children(p12);
			t22 = claim_text(p12_nodes, t22_value);
			t23 = claim_text(p12_nodes, "km");
			p12_nodes.forEach(detach);
			li7_nodes.forEach(detach);
			li8 = claim_element(ul4_nodes, "LI", { class: true });
			var li8_nodes = children(li8);
			p13 = claim_element(li8_nodes, "P", { class: true });
			var p13_nodes = children(p13);
			t24 = claim_text(p13_nodes, "修復歴");
			p13_nodes.forEach(detach);
			p14 = claim_element(li8_nodes, "P", { class: true });
			var p14_nodes = children(p14);
			t25 = claim_text(p14_nodes, t25_value);
			p14_nodes.forEach(detach);
			li8_nodes.forEach(detach);
			ul4_nodes.forEach(detach);
			li9_nodes.forEach(detach);
			ul5_nodes.forEach(detach);
			div4_nodes.forEach(detach);
			div5 = claim_element(article_nodes, "DIV", { class: true });
			var div5_nodes = children(div5);
			claim_component(options.$$.fragment, div5_nodes);
			div5_nodes.forEach(detach);
			article_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(h1, "class", "svelte-on555q");
			attr(li0, "class", "status svelte-on555q");
			toggle_class(li0, "sold", /*car*/ ctx[0].sold);
			attr(ul0, "class", "svelte-on555q");
			attr(div0, "class", "heading svelte-on555q");
			attr(ul1, "class", "svelte-on555q");
			attr(div1, "class", "slider-content svelte-on555q");
			attr(span0, "class", "prev svelte-on555q");
			attr(span1, "class", "next svelte-on555q");
			attr(div2, "class", "slider svelte-on555q");
			attr(ul2, "class", "images svelte-on555q");
			attr(p0, "class", "svelte-on555q");
			attr(strong0, "class", "svelte-on555q");
			attr(p1, "class", "svelte-on555q");
			attr(strong1, "class", "svelte-on555q");
			attr(p2, "class", "svelte-on555q");
			attr(div3, "class", "svelte-on555q");
			attr(li1, "class", "svelte-on555q");
			attr(p3, "class", "svelte-on555q");
			attr(p4, "class", "svelte-on555q");
			attr(li2, "class", "svelte-on555q");
			attr(p5, "class", "svelte-on555q");
			attr(p6, "class", "svelte-on555q");
			attr(li3, "class", "svelte-on555q");
			attr(p7, "class", "svelte-on555q");
			attr(p8, "class", "svelte-on555q");
			attr(li4, "class", "svelte-on555q");
			attr(ul3, "class", "svelte-on555q");
			attr(li5, "class", "svelte-on555q");
			attr(p9, "class", "svelte-on555q");
			attr(p10, "class", "svelte-on555q");
			attr(li6, "class", "svelte-on555q");
			attr(p11, "class", "svelte-on555q");
			attr(p12, "class", "svelte-on555q");
			attr(li7, "class", "svelte-on555q");
			attr(p13, "class", "svelte-on555q");
			attr(p14, "class", "svelte-on555q");
			attr(li8, "class", "svelte-on555q");
			attr(ul4, "class", "svelte-on555q");
			attr(li9, "class", "svelte-on555q");
			attr(ul5, "class", "svelte-on555q");
			attr(div4, "class", "details svelte-on555q");
			attr(div5, "class", "options svelte-on555q");
		},
		m(target, anchor) {
			insert(target, article, anchor);
			append(article, div0);
			append(div0, h1);
			append(h1, t0);
			append(div0, ul0);
			append(ul0, li0);
			append(li0, t1);
			if (if_block) if_block.m(ul0, null);
			append(article, div2);
			append(div2, div1);
			append(div1, ul1);

			for (let i = 0; i < each_blocks_1.length; i += 1) {
				each_blocks_1[i].m(ul1, null);
			}

			append(div2, span0);
			append(span0, t2);
			append(div2, span1);
			append(span1, t3);
			append(article, ul2);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul2, null);
			}

			append(article, div4);
			append(div4, ul5);
			append(ul5, li1);
			append(li1, p0);
			append(p0, t4);
			append(li1, div3);
			append(div3, p1);
			append(p1, span2);
			append(span2, t5);
			append(p1, strong0);
			append(strong0, t6);
			append(p1, span3);
			append(span3, t7);
			append(div3, p2);
			append(p2, span4);
			append(span4, t8);
			append(p2, strong1);
			append(strong1, t9);
			append(p2, span5);
			append(span5, t10);
			append(ul5, li5);
			append(li5, ul3);
			append(ul3, li2);
			append(li2, p3);
			append(p3, t11);
			append(li2, p4);
			append(p4, t12);
			append(ul3, li3);
			append(li3, p5);
			append(p5, t13);
			append(li3, p6);
			append(p6, t14);
			append(p6, t15);
			append(ul3, li4);
			append(li4, p7);
			append(p7, t16);
			append(li4, p8);
			append(p8, t17);
			append(ul5, li9);
			append(li9, ul4);
			append(ul4, li6);
			append(li6, p9);
			append(p9, t18);
			append(li6, p10);
			append(p10, t19);
			append(p10, t20);
			append(ul4, li7);
			append(li7, p11);
			append(p11, t21);
			append(li7, p12);
			append(p12, t22);
			append(p12, t23);
			append(ul4, li8);
			append(li8, p13);
			append(p13, t24);
			append(li8, p14);
			append(p14, t25);
			append(article, div5);
			mount_component(options, div5, null);
			current = true;
		},
		p(ctx, [dirty]) {
			if ((!current || dirty & /*car*/ 1) && t0_value !== (t0_value = /*car*/ ctx[0].title + "")) set_data(t0, t0_value);
			if ((!current || dirty & /*car*/ 1) && t1_value !== (t1_value = (/*car*/ ctx[0].sold ? "成約済み" : "販売中") + "")) set_data(t1, t1_value);

			if (dirty & /*car*/ 1) {
				toggle_class(li0, "sold", /*car*/ ctx[0].sold);
			}

			if (/*car*/ ctx[0].category) {
				if (if_block) {
					if_block.p(ctx, dirty);
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					if_block.m(ul0, null);
				}
			} else if (if_block) {
				if_block.d(1);
				if_block = null;
			}

			if (dirty & /*car*/ 1) {
				each_value_1 = /*car*/ ctx[0].images;
				let i;

				for (i = 0; i < each_value_1.length; i += 1) {
					const child_ctx = get_each_context_1(ctx, each_value_1, i);

					if (each_blocks_1[i]) {
						each_blocks_1[i].p(child_ctx, dirty);
					} else {
						each_blocks_1[i] = create_each_block_1(child_ctx);
						each_blocks_1[i].c();
						each_blocks_1[i].m(ul1, null);
					}
				}

				for (; i < each_blocks_1.length; i += 1) {
					each_blocks_1[i].d(1);
				}

				each_blocks_1.length = each_value_1.length;
			}

			if (dirty & /*car*/ 1) {
				each_value = /*car*/ ctx[0].images;
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(ul2, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if ((!current || dirty & /*car*/ 1) && t4_value !== (t4_value = /*car*/ ctx[0].title + "")) set_data(t4, t4_value);
			if ((!current || dirty & /*car*/ 1) && t6_value !== (t6_value = (/*car*/ ctx[0].price ? /*car*/ ctx[0].price : "ASK") + "")) set_data(t6, t6_value);

			if ((!current || dirty & /*car*/ 1) && t9_value !== (t9_value = (/*car*/ ctx[0].totalPrice
			? /*car*/ ctx[0].totalPrice
			: "ASK") + "")) set_data(t9, t9_value);

			if ((!current || dirty & /*car*/ 1) && t12_value !== (t12_value = (/*car*/ ctx[0].maker?.name || "-") + "")) set_data(t12, t12_value);
			if ((!current || dirty & /*car*/ 1) && t14_value !== (t14_value = (/*car*/ ctx[0].modelYear || "- ") + "")) set_data(t14, t14_value);
			if ((!current || dirty & /*car*/ 1) && t17_value !== (t17_value = (/*car*/ ctx[0].vehicleInspection || "-") + "")) set_data(t17, t17_value);
			if ((!current || dirty & /*car*/ 1) && t19_value !== (t19_value = (/*car*/ ctx[0].capacity || "- ") + "")) set_data(t19, t19_value);
			if ((!current || dirty & /*car*/ 1) && t22_value !== (t22_value = (/*car*/ ctx[0].mileage || "- ") + "")) set_data(t22, t22_value);
			if ((!current || dirty & /*car*/ 1) && t25_value !== (t25_value = (/*car*/ ctx[0].repairHistory ? "有" : "無") + "")) set_data(t25, t25_value);
			const options_changes = {};
			if (dirty & /*car*/ 1) options_changes.options = /*car*/ ctx[0].options;
			options.$set(options_changes);
		},
		i(local) {
			if (current) return;
			transition_in(options.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(options.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(article);
			if (if_block) if_block.d();
			destroy_each(each_blocks_1, detaching);
			destroy_each(each_blocks, detaching);
			destroy_component(options);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	
	let { car } = $$props;

	onMount(() => {
		const sliderElem = document.getElementsByClassName("slider")[0],
			sliderListElem = sliderElem.getElementsByTagName("ul")[0],
			sliderItemElems = sliderListElem.getElementsByTagName("li"),
			nextElem = sliderElem.getElementsByClassName("next")[0],
			prevElem = sliderElem.getElementsByClassName("prev")[0],
			imagesListElem = document.getElementsByClassName("images")[0],
			imagesItemElems = imagesListElem.getElementsByTagName("li");

		let count = 0;
		sliderListElem.style.width = `calc(100% * ${sliderItemElems.length})`;

		Array.from(sliderItemElems).forEach((i, n) => {
			i.style.width = `calc(100% / ${sliderItemElems.length})`;
		});

		const setTransform = () => {
			const value = 100 / sliderItemElems.length * count;
			sliderListElem.style.transform = `translateX(calc(0px - ${value}%)`;
		};

		const setDisabled = () => {
			const enabledCss = elem => {
				elem.style.cssText = `
          cursor: pointer;
          opacity: 1;
          pointer-events: auto;
        `;
			};

			const disabledCss = elem => {
				elem.style.cssText = `
          cursor: default;
          opacity: 0.6;
          pointer-events: none;
        `;
			};

			count === 0
			? disabledCss(prevElem)
			: enabledCss(prevElem);

			count === sliderItemElems.length - 1
			? disabledCss(nextElem)
			: enabledCss(nextElem);
		};

		setDisabled();

		nextElem.onclick = () => {
			count++;
			setTransform();
			setDisabled();
		};

		prevElem.onclick = () => {
			count--;
			setTransform();
			setDisabled();
		};

		Array.from(imagesItemElems).forEach((i, n) => {
			i.onclick = () => {
				count = n;
				setTransform();
				setDisabled();
			};
		});
	});

	$$self.$$set = $$props => {
		if ("car" in $$props) $$invalidate(0, car = $$props.car);
	};

	return [car];
}

class Article extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { car: 0 });
	}
}

export default Article;
//# sourceMappingURL=Article.js.map
